import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { shellStyles } from '../components/layout/shellLayout';

/** Persistent strip shown while the device is offline - sits below fixed header. */
export function OfflineBanner() {
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="fixed inset-x-0 z-[80] flex items-center justify-center gap-2 bg-amber-500/90 px-3 py-1.5 text-center text-xs font-medium text-black"
      style={{ top: shellStyles.bannerTop }}
    >
      <WifiOff className="h-3.5 w-3.5" aria-hidden />
      You&apos;re offline - showing the last loaded data.
    </div>
  );
}
